import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import Panel from "@/layout/Panel";
import PanelTitle from "@/layout/PanelTitle";

function HotelPanel({ children }: { children: ReactNode }) {
    const { t } = useTranslation();

    return (
        <Panel
            title={
                <PanelTitle title={t("hotelPlanning")}>
                    {/* <div className="col-span-12 md:col-span-6 flex items-center justify-end gap-2">
                        <Alert severity="warning">{t("infos.hotelPlanningInfo")}</Alert>
                    </div> */}
                </PanelTitle>
            }
        >
            {children}
        </Panel>
    );
}

export default HotelPanel;
